import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "../../components/CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { Button, Chip, Stack, Box } from "@mui/material";
import { CssBaseline } from "@material-ui/core";

import { Tooltip } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import ConfirmationDialog from "../ConfirmationDialog";
import { setEventcustomisation } from "../../redux/slices/eventcustomisationsSlice";
import MediaViewerDialog from "./MediaViewerDialog";
import TableStatus from "../TableStatus";

const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      width: "100%",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const EventCustomisationTable = ({
  selectedOption,
  responseData,
  errors, isLoading,
  dataType,
}) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const eventcustomisationsData = useSelector(
    (state) => state.eventcustomisations
  );
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [maker, setMaker] = useState("");
  const resolutions = useSelector((state) => state?.resolution?.resolutions);

  const handleViewImages = (images) => {
    setCurrentImages(images);
    setCurrentImageIndex(0);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => setOpenViewModal(false);
  const handlePreviousImage = () =>
    setCurrentImageIndex((prev) => Math.max(prev - 1, 0));
  const handleNextImage = () =>
    setCurrentImageIndex((prev) =>
      Math.min(prev + 1, currentImages.length - 1)
    );

  const parseResolutionValue = (value) => {
    const [wStr, hStr] = value.split("x");
    return {
      width: parseInt(wStr, 10),
      height: parseInt(hStr, 10),
    };
  };

  const ratio = (w, h) => Math.round((w / h) * 100) / 100;
  const area = (w, h) => w * h;

  const isAspectRatioMatching = (imgW, imgH, resW, resH) =>
    ratio(imgW, imgH) === ratio(resW, resH);

  const isTooSmall = (imgW, imgH, resW, resH) =>
    area(resW, resH) >= 5 * area(imgW, imgH);

  const columns = [
    {
      field: "image",
      headerName: "Image",
      flex: 2,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const imageUrl = params?.row?.customisations?.[0]?.imageUrl || null;
        const isVideo = imageUrl ? /\.(mp4|avi|mov)$/i.test(imageUrl) : false;

        return imageUrl ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {isVideo ? (
              <video
                controls
                style={{
                  width: "150px",
                  height: "105px",
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <source src={imageUrl} type="video/mp4" />
                <source src={imageUrl} type="video/avi" />
                <source src={imageUrl} type="video/mov" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={imageUrl}
                alt="Customisation"
                style={{
                  width: "150px",
                  height: "105px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              />
            )}
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>No Media</div>
        );
      },
    },

    {
      field: "eventCustomisationName",
      headerName: "Name",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "suitable",
      headerName: "Suitable Screens",
      flex: 1.4,
      minWidth: 160,
      renderCell: (params) => {
        const customProps = params?.row?.customProperties?.metaData || {};
    
        const imgWidth = customProps.width;
        const imgHeight = customProps.height;
        if (!imgWidth || !imgHeight) {
          return (
            <Chip
              label="Missing metadata"
              size="small"
              color="error"
              variant="filled"
              sx={{ fontSize: "0.75rem" }}
            />
          );
        }

        const matchingResolutions = (resolutions || [])
          .map((res) => {
            if (!res.value) return null;
            const { width: resW, height: resH } = parseResolutionValue(
              res.value
            );

            if (!resW || !resH) return null;

            const matchesAspect = isAspectRatioMatching(
              imgWidth,
              imgHeight,
              resW,
              resH
            );
            if (!matchesAspect) return null;

            const tooSmall = isTooSmall(imgWidth, imgHeight, resW, resH);

            return {
              name: res.name || res.value,
              tooSmall,
            };
          })
          .filter(Boolean);

        return (
          <Stack
            direction="column"
            spacing={0.5}
            alignItems="center"
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              overflowY: "auto", 
              maxHeight: "100%", 
            }}
          >
            {matchingResolutions.length > 0 ? (
              matchingResolutions.map((res, index) => (
                <Tooltip
                  key={index}
                  title={
                    res.tooSmall
                      ? "⚠️ Poor fit for this resolution (image is too small)"
                      : "✅ Good resolution match"
                  }
                  arrow
                  enterDelay={200}
                  leaveDelay={100}
                  followCursor
                  disableInteractive
                >
                  <Chip
                    label={res.name}
                    size="small"
                    color={res.tooSmall ? "warning" : "success"}
                    variant="filled"
                    sx={{
                      fontSize: "0.75rem",
                      cursor: "default",
                      maxWidth: "100%",
                      width: "auto",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  />
                </Tooltip>
              ))
            ) : (
              <Chip
                label="No matching resolutions"
                size="small"
                color="warning"
                variant="filled"
                sx={{ fontSize: "0.75rem" }}
              />
            )}
          </Stack>
        );
      },
    },
    { field: "maker", headerName: "Maker", flex: 1, minWidth: 120 },
    { field: "checker", headerName: "Checker", flex: 1, minWidth: 120 },
    {
      field: "view",
      headerName: "View",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          startIcon={<VisibilityIcon />}
          onClick={() =>
            handleViewImages(
              params?.row?.customisations?.map((c) => c.imageUrl) || []
            )
          }
        >
          View
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => {
            handleDelete(params?.row?.meetingCustomisationId);

            setMaker(params?.row?.maker);
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "eventcustomisation",
      query: { customisationId: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setRows((prevRows) => {
         
          const updatedRows = prevRows?.filter(
            (row) => row.id !== response.data.id
          );

          
          dispatch(setEventcustomisation(updatedRows));

          return updatedRows;
        });
      })

      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (eventcustomisationsData?.eventcustomisations) {
      setRows(eventcustomisationsData?.eventcustomisations);
    }
  }, [eventcustomisationsData?.eventcustomisations]);

  const filteredRows = rows.filter((row) => {
    const isImageAI = row?.customisations?.[0]?.imageAi;
    const maker = row?.maker;
    if (maker === "client-url-system") return false;
    return dataType === "contentAI" ? isImageAI : !isImageAI;
  });

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={filteredRows}
                 columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                rowHeight={120}
              />
            </div>

            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                contentAI={true}
                maker={maker}
              />
            )}

            <MediaViewerDialog
              open={openViewModal}
              onClose={handleCloseViewModal}
              currentImages={currentImages}
              currentImageIndex={currentImageIndex}
              handlePreviousImage={handlePreviousImage}
              handleNextImage={handleNextImage}
            />
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default EventCustomisationTable;
